var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFavouriteFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.2,1c-2.5-0.4-4.8,0.4-6.2,2.1C10.6,1.4,8.3,0.6,5.8,1C3.1,1.5,0,3.7,0,8.3c0,2.8,1.5,8.5,11.5,14.7 c0.1,0.1,0.3,0.1,0.5,0.1s0.4-0.1,0.5-0.2C22.5,16.7,24,11.1,24,8.3C24,3.7,20.9,1.5,18.2,1z M12,20.9C3.3,15.4,2,10.6,2,8.3 c0-3.4,2.1-5,4.1-5.3C6.4,2.9,6.7,2.9,7,2.9c1.7,0,3.4,0.8,4.2,2.5c0.1,0.4,0.5,0.7,0.9,0.7c0.4,0,0.8-0.3,0.9-0.7 c0.7-2.1,3.1-2.7,4.9-2.4c2,0.3,4.1,1.9,4.1,5.3C22,10.7,20.7,15.4,12,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22,8.3c0,2.4-1.3,7.1-10,12.6C3.3,15.4,2,10.6,2,8.3c0-3.4,2.1-5,4.1-5.3C6.4,2.9,6.7,2.9,7,2.9 c1.7,0,3.4,0.8,4.2,2.5c0.1,0.4,0.5,0.7,0.9,0.7c0.4,0,0.8-0.3,0.9-0.7c0.7-2.1,3.1-2.7,4.9-2.4C19.9,3.3,22,4.9,22,8.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavouriteFill);
export default __webpack_public_path__ + "static/media/icon-favourite-fill.5b7ab312e244789c5dd0d580a9e3ca8c.svg";
export { ForwardRef as ReactComponent };